import type { AppRoute } from "@/lib/routing";
import { ReviewPage } from "./ReviewPage";

export const routes: AppRoute[] = [
  {
    path: "/review",
    element: <ReviewPage />,
    handle: {
      title: "Review",
      keywords: ["data review", "queue", "conflicts", "identity", "CAS conflict", "unresolved"],
    },
  },
];
